<template>
  <v-row>
    <div
      v-if="description"
      v-html="description"
      class="description"
    >
    </div>
    <ValidationProvider :name="field.name" slim mode="eager" :rules="rules" v-slot="{ errors }">
      <v-text-field
        :type="field.type"
        :label="`${placeholder} ${requiredHint}`"
        :error-messages="errors[0]"
        @keydown.native.e="ignoreLetterE"
        v-model="value"></v-text-field>
    </ValidationProvider>
  </v-row>
</template>

<script>
  import _ from 'lodash'
  import {getFieldRules} from '@/utils/auth/validation'

  export default {
    name: 'TextField',
    props: ['field'],
    data: () => ({
      value: '',
    }),
    computed: {
      placeholder() {
        return this.field.placeholder ? this.$t(this.field.placeholder) : this.field.name;
      },
      requiredHint() {
        return this.field.required ? ' *' : '';
      },
      description() {
        const fieldDescription =
          _.get(this.field, 'metadata.description', '') || _.get(this.field, 'description', '')

        if (!_.isEmpty(fieldDescription)) {
          return fieldDescription
        }

        return ''
      },
      rules() {
        return getFieldRules(this.field)
      }
    },
    methods: {
      ignoreLetterE(event) {
        if (this.field.type === 'number') {
          event.preventDefault();
        }
      }
    },
    watch: {
      value() {
        this.$emit('setText', {
          key: this.field.key,
          value: this.value,
          identity: this.field.identity ? this.field.identity : false
        })
      }
    }
  }
</script>

<style scoped>

</style>
